<nav class="navbar navbar-expand-lg shadow-sm">
    <div class="toggleSidebar ps-3">
            <i class="bi bi-justify" 
              [ngClass]="{'d-block':isCollapsed, 'd-none':!isCollapsed}"
              data-bs-toggle="tooltip" data-bs-placement="top" 
              [title]="'Expand menu'"
              (click)="toggleSidebar()"></i>
        <a class="navbar-brand global-title">PayMe - Pension</a>
    </div>
     
     <div class="navbar-actions d-flex align-items-center ms-auto">
      <div class="dropdown border" *ngIf="!IsMobileView">
        <button class="btn dropdown-toggle language-select" type="button" data-bs-toggle="dropdown">
          <span class="fi me-2" [ngClass]="{'fi-us': translate.currentLang == 'en', 'fi-mm':translate.currentLang == 'my'}"></span>{{translate.currentLang == 'en'? 'English':'မြန်မာ'}}
        </button>
        <ul class="dropdown-menu">
          <li class="cursor-pointer"><a class="dropdown-item" (click)="changeLanguage('en')"><span class="fi fi-us me-2"></span>English</a></li>
          <li class="cursor-pointer"><a class="dropdown-item" (click)="changeLanguage('my')"><span class="fi fi-mm me-2"></span>မြန်မာ</a></li>
        </ul>
      </div>

      <div class="col" *ngIf="IsMobileView">
        <select class="form-select" [(ngModel)]="systemLang" (change)="onChange($event)" aria-label="Default select example">
          <option value="en">EN</option>
          <option value="my">MM</option>
        </select>
      </div>
      <div class="navbar-logout">
          <a class="btn btn-logout fw-bold ms-auto border-0" data-bs-toggle="modal"
           data-bs-target="#staticBackdropForLogout">Log Out</a>
      </div>
   </div>
      
</nav>


<!-- Modal -->
<div class="modal fade" id="staticBackdropForLogout" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content py-2 px-4">
      <div class="modal-header border-0">
        <h5 class="modal-title" id="staticBackdropLabel">Ready to Leave?</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body border-0">
        <div class="row">
          <div class="col-md-12">
            Select "Logout" below if you are ready to end your current session.
          </div>
        </div>
      </div>
      <div class="modal-footer border-0">
        <div class="col-md-2">
          <a id="cancelButton" class="btn global-filter-button form-control py-2" data-bs-dismiss="modal">Cancel</a>
        </div>
        <div class="col-md-2">
          <app-button 
            [buttonText]="'Logout'"
            [buttonColor]="'#FF3B30'" [btnClassName]="'text-white'"
            data-bs-dismiss="modal"
            [page]="'approverRemark'"
            (buttonClick)="logout()">
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>